import { ColDef, IFilterParams, ValueFormatterParams } from 'ag-grid-community'
import {
  WbsItemAdditionalPropertyEntity,
  WbsItemAdditionalPropertySelectOption,
} from '../../../../../../domain/entity/WbsItemAdditionalPropertyEntity'
import { Option } from '..'
import { SelectCellEditor } from '../../../components/cellEditor'
import {
  ClientSideSelectFilter,
  SelectFilter,
  ServerSideSelectFilter,
} from '../../../components/filter'
import { filter } from '../../../../../pages/ProjectPlanNew/projectPlanNew'
import { wbsItemAdditionalPropertyValuesVoService } from '../../../../../../domain/value-object/WbsItemAdditionalPropertyValuesVO'
import { ColumnType } from '../../../../commons/AgGrid'

type SelectOptionMap = {
  [selectOptionUuid: string]: WbsItemAdditionalPropertySelectOption
}
export const selectColumnDef = <RowData>(
  column: ColDef,
  wbsItemAdditionalProperty: WbsItemAdditionalPropertyEntity,
  option: Option<RowData>
): void => {
  const selectOptionMap: SelectOptionMap = {}
  wbsItemAdditionalProperty.selectOptions?.forEach(selectOption => {
    selectOptionMap[selectOption.uuid] = selectOption
  })
  column.type = [ColumnType.selectNotCustomEnum]
  column.valueFormatter = (params: ValueFormatterParams<RowData>) => {
    return params.value
      ? (selectOptionMap[params.value]?.selectOption ?? '')
      : ''
  }
  column.cellEditor = SelectCellEditor
  column.cellEditorParams = {
    options: wbsItemAdditionalProperty.selectOptions
      ? wbsItemAdditionalProperty.selectOptions.map(selectOption => ({
          label: selectOption.selectOption,
          value: selectOption.uuid,
        }))
      : [],
  }
  setFilterParams(column, wbsItemAdditionalProperty, selectOptionMap, option)
  return
}
const setFilterParams = <RowData>(
  column: ColDef,
  wbsItemAdditionalProperty: WbsItemAdditionalPropertyEntity,
  selectOptionMap: SelectOptionMap,
  option: Option<RowData>
) => {
  switch (option.columnFilterType) {
    case 'CLIENT_SIDE':
      column.filter = ClientSideSelectFilter
      column.floatingFilter = !option.disableFloatingFilter
      column.filterParams = {
        valueGetter: params => {
          const additionalPropertyValues = option.getAdditionalPropertyValues(
            params.node.data
          )
          if (!additionalPropertyValues) return
          return wbsItemAdditionalPropertyValuesVoService.getValue(
            additionalPropertyValues,
            wbsItemAdditionalProperty.uuid
          )
        },
        getValue: o => o,
        getLabel: o => selectOptionMap[o]?.selectOption ?? '',
        sortValues: (_, options) => {
          return options.sort((a, b) => {
            const aOption = selectOptionMap[a]
            const bOption = selectOptionMap[b]
            return aOption?.displayOrder - bOption?.displayOrder
          })
        },
      }
      break
    case 'SERVER_SIDE':
      column.filter = ServerSideSelectFilter
      column.floatingFilter = !option.disableFloatingFilter
      column.filterParams = {
        fetchOptions: async (params: IFilterParams) => {
          return wbsItemAdditionalProperty.selectOptions
            ? wbsItemAdditionalProperty.selectOptions.map(selectOption => ({
                label: selectOption.selectOption,
                value: selectOption.uuid,
              }))
            : []
        },
        getValue: o => o.value,
        getLabel: o => o.label,
        fetch: (v: SelectFilter) => {
          return filter({
            projectUuid: wbsItemAdditionalProperty.projectUuid,
            additionalPropertyValues: [
              {
                wbsItemAdditionalPropertyUuid: wbsItemAdditionalProperty.uuid,
                propertyType: wbsItemAdditionalProperty.propertyType,
                values: v.values,
                includeBlank: v.includeBlank,
              },
            ],
          })
        },
        sortValues: options => {
          return options.sort((a, b) => {
            const aOption = a ? selectOptionMap[a.value] : undefined
            const bOption = b ? selectOptionMap[b.value] : undefined
            return (aOption?.displayOrder || 0) - (bOption?.displayOrder || 0)
          })
        },
      }
      break
    default:
      break
  }
}
